import Vue from "vue";

Vue.filter('spacedNumber', function (value) {
  if (value == null) return value
  const parts = value.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  return parts.join(".");
})
